import { supabase } from './supabaseClient';

// Core integrations replacement
export const Core = {
    // Integração com LLM (você pode integrar com OpenAI, Anthropic, etc.)
    InvokeLLM: async (prompt, options = {}) => {
        try {
            // Aqui você pode integrar com qualquer serviço de LLM
            // Por exemplo, OpenAI, Anthropic Claude, ou usar Edge Functions do Supabase
            const { data, error } = await supabase.functions.invoke('invoke-llm', {
                body: { prompt, options }
            });
            
            if (error) throw error;
            return data;
        } catch (error) {
            console.error('Erro ao invocar LLM:', error);
            throw error;
        }
    },

    // Envio de emails via Supabase Edge Functions
    SendEmail: async (to, subject, content, options = {}) => {
        try {
            const { data, error } = await supabase.functions.invoke('send-email', {
                body: { to, subject, content, options }
            });
            
            if (error) throw error;
            return data;
        } catch (error) {
            console.error('Erro ao enviar email:', error);
            throw error;
        }
    },

    // Upload de arquivos para Supabase Storage
    UploadFile: async (file, bucket = 'uploads', path = null) => {
        try {
            // Validação do arquivo
            if (!file || !file.name || !file.type) {
                throw new Error('Arquivo inválido: arquivo, nome ou tipo não definidos');
            }
            
            const fileName = path || `${Date.now()}-${file.name}`;
            
            console.log('📤 Tentando upload para:', {
                bucket,
                fileName,
                fileType: file.type,
                fileSize: file.size
            });
            
            const { data, error } = await supabase.storage
                .from(bucket)
                .upload(fileName, file, {
                    cacheControl: '3600',
                    upsert: false
                });
            
                         if (error) {
                 console.error('❌ Erro no upload:', error);
                 
                 // Tratar erro RLS especificamente
                 if (error.statusCode === '403' && error.message?.includes('row-level security policy')) {
                     console.error('🔒 Erro RLS: O bucket ou políticas de acesso não estão configurados corretamente');
                     console.log('📋 Para corrigir: Execute o script create-storage-buckets.sql no painel SQL do Supabase');
                     
                     // Tentar criar bucket público temporário como fallback
                     try {
                         console.warn('⚠️ Tentando fallback com bucket público temporário...');
                         
                         const fallbackUpload = await supabase.storage
                             .from('uploads')
                             .upload(fileName, file, {
                                 cacheControl: '3600',
                                 upsert: true // Permitir sobrescrever
                             });
                             
                         if (fallbackUpload.error) {
                             console.error('❌ Fallback também falhou:', fallbackUpload.error);
                             throw new Error('CONFIGURE_STORAGE: Execute o script create-storage-buckets.sql no Supabase para configurar o storage corretamente.');
                         }
                         
                         const { data: { publicUrl } } = supabase.storage
                             .from('uploads')
                             .getPublicUrl(fileName);
                         
                         console.warn('✅ Upload realizado via fallback - configure o storage adequadamente');
                         
                         return {
                             path: fallbackUpload.data.path,
                             fullPath: fallbackUpload.data.fullPath,
                             url: publicUrl,
                             bucket: 'uploads'
                         };
                     } catch (fallbackError) {
                         throw new Error('STORAGE_NOT_CONFIGURED: O Supabase Storage não está configurado. Execute o script create-storage-buckets.sql no painel SQL do Supabase.');
                     }
                 }
                 
                 // Tentar bucket padrão se o bucket específico falhar
                 if (bucket !== 'uploads' && (error.message?.includes('not found') || error.statusCode === '404')) {
                     console.warn(`⚠️ Bucket '${bucket}' não encontrado, tentando bucket padrão 'uploads'`);
                     
                     const fallbackUpload = await supabase.storage
                         .from('uploads')
                         .upload(fileName, file, {
                             cacheControl: '3600',
                             upsert: false
                         });
                         
                     if (fallbackUpload.error) throw fallbackUpload.error;
                     
                     const { data: { publicUrl } } = supabase.storage
                         .from('uploads')
                         .getPublicUrl(fileName);
                     
                     return {
                         path: fallbackUpload.data.path,
                         fullPath: fallbackUpload.data.fullPath,
                         url: publicUrl,
                         bucket: 'uploads'
                     };
                 }
                 
                 throw error;
             }
            
            // Obter URL pública do arquivo
            const { data: { publicUrl } } = supabase.storage
                .from(bucket)
                .getPublicUrl(fileName);
            
            console.log('✅ Upload concluído:', {
                path: data.path,
                url: publicUrl
            });
            
            console.log('🔗 Detalhes da URL pública gerada:', {
                bucket: bucket,
                fileName: fileName,
                publicUrl: publicUrl,
                isValidUrl: publicUrl && publicUrl.startsWith('http'),
                urlLength: publicUrl?.length
            });
            
            return {
                path: data.path,
                fullPath: data.fullPath,
                url: publicUrl,
                bucket: bucket
            };
        } catch (error) {
            console.error('❌ Erro ao fazer upload:', error);
            
                         // Melhorar mensagens de erro
             if (error.message?.includes('invalid_mime_type')) {
                 throw new Error(`Tipo de arquivo não suportado: ${file.type}. Use apenas imagens (JPEG, PNG, WebP).`);
             } else if (error.message?.includes('too_large')) {
                 throw new Error('Arquivo muito grande. O tamanho máximo é 10MB.');
             } else if (error.statusCode === '415') {
                 throw new Error(`Formato de arquivo não suportado: ${file.type}`);
             } else if (error.message?.includes('STORAGE_NOT_CONFIGURED')) {
                 throw new Error('⚠️ CONFIGURAÇÃO NECESSÁRIA: Acesse o painel do Supabase → SQL Editor → Cole e execute o código do arquivo create-storage-buckets.sql');
             } else if (error.message?.includes('CONFIGURE_STORAGE')) {
                 throw new Error('⚠️ CONFIGURAÇÃO NECESSÁRIA: Execute o script create-storage-buckets.sql no painel SQL do Supabase');
             }
             
             throw error;
        }
    },

    // Geração de imagens (integração com serviços externos)
    GenerateImage: async (prompt, options = {}) => {
        try {
            const { data, error } = await supabase.functions.invoke('generate-image', {
                body: { prompt, options }
            });
            
            if (error) throw error;
            return data;
        } catch (error) {
            console.error('Erro ao gerar imagem:', error);
            throw error;
        }
    },

    // Extração de dados de arquivos
    ExtractDataFromUploadedFile: async (fileUrl, options = {}) => {
        try {
            const { data, error } = await supabase.functions.invoke('extract-file-data', {
                body: { fileUrl, options }
            });
            
            if (error) throw error;
            return data;
        } catch (error) {
            console.error('Erro ao extrair dados:', error);
            throw error;
        }
    }
};

// Funções auxiliares para relatórios e analytics
export const Analytics = {
    // Gerar relatórios de tickets
    async getTicketReports(companyId, dateRange = {}) {
        const { data, error } = await supabase.rpc('get_ticket_reports', {
            company_id_param: companyId,
            start_date: dateRange.start,
            end_date: dateRange.end
        });
        
        if (error) throw error;
        return data;
    },



    // Relatórios de produtividade
    async getProductivityReports(companyId, userId = null, dateRange = {}) {
        const { data, error } = await supabase.rpc('get_productivity_reports', {
            company_id_param: companyId,
            user_id_param: userId,
            start_date: dateRange.start,
            end_date: dateRange.end
        });
        
        if (error) throw error;
        return data;
    }
};

// Funções de notificação
export const Notifications = {
    // Criar notificação para usuário
    async create(userId, title, message, type = 'info', data = {}) {
        const { data: notification, error } = await supabase
            .from('user_notifications')
            .insert({
                user_id: userId,
                title,
                message,
                type,
                data
            })
            .select()
            .single();
        
        if (error) throw error;
        return notification;
    },

    // Marcar como lida
    async markAsRead(notificationId) {
        const { error } = await supabase
            .from('user_notifications')
            .update({ is_read: true })
            .eq('id', notificationId);
        
        if (error) throw error;
        return true;
    },

    // Marcar todas como lidas
    async markAllAsRead(userId) {
        const { error } = await supabase
            .from('user_notifications')
            .update({ is_read: true })
            .eq('user_id', userId)
            .eq('is_read', false);
        
        if (error) throw error;
        return true;
    }
};

// Funções de websocket/realtime
export const Realtime = {
    // Subscrever a mudanças em uma tabela
    subscribe(table, callback, filters = {}) {
        let channel = supabase
            .channel(`public:${table}`)
            .on('postgres_changes', {
                event: '*',
                schema: 'public',
                table: table,
                filter: Object.entries(filters).map(([key, value]) => `${key}=eq.${value}`).join('&')
            }, callback);
        
        channel.subscribe();
        return channel;
    },

    // Subscrever a um canal de chat
    subscribeToChat(roomId, callback) {
        const channel = supabase
            .channel(`chat-${roomId}`)
            .on('postgres_changes', {
                event: 'INSERT',
                schema: 'public',
                table: 'chat_messages',
                filter: `room_id=eq.${roomId}`
            }, callback);
        
        channel.subscribe();
        return channel;
    },

    // Desinscrever de um canal
    unsubscribe(channel) {
        if (channel) {
            supabase.removeChannel(channel);
        }
    }
};

// Funções de backup e exportação
export const Export = {
    // Exportar dados de tickets
    async exportTickets(companyId, format = 'json', filters = {}) {
        const { data, error } = await supabase.functions.invoke('export-data', {
            body: {
                table: 'tickets',
                company_id: companyId,
                format,
                filters
            }
        });
        
        if (error) throw error;
        return data;
    },

    // Exportar dados de clientes
    async exportClients(companyId, format = 'json') {
        const { data, error } = await supabase.functions.invoke('export-data', {
            body: {
                table: 'clients',
                company_id: companyId,
                format
            }
        });
        
        if (error) throw error;
        return data;
    }
};

// Re-exportar como anteriormente usado
export const InvokeLLM = Core.InvokeLLM;
export const SendEmail = Core.SendEmail;
export const UploadFile = Core.UploadFile;
export const GenerateImage = Core.GenerateImage;
export const ExtractDataFromUploadedFile = Core.ExtractDataFromUploadedFile; 